var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPricingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM7.11 14.9C7.11 15.18 6.89 15.4 6.61 15.4H3.82C3.54 15.4 3.32 15.18 3.32 14.9V10.28C3.32 9.65 3.83 9.14 4.46 9.14H6.61C6.89 9.14 7.11 9.36 7.11 9.64V14.9ZM11.89 14.9C11.89 15.18 11.67 15.4 11.39 15.4H8.6C8.32 15.4 8.1 15.18 8.1 14.9V5.74C8.1 5.11 8.61 4.6 9.24 4.6H10.76C11.39 4.6 11.9 5.11 11.9 5.74V14.9H11.89ZM16.68 14.9C16.68 15.18 16.46 15.4 16.18 15.4H13.39C13.11 15.4 12.89 15.18 12.89 14.9V11.35C12.89 11.07 13.11 10.85 13.39 10.85H15.54C16.17 10.85 16.68 11.36 16.68 11.99V14.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPricingActive);
export default __webpack_public_path__ + "static/media/sidebar-pricing-active.5a409d84699df116c4064cd995e453f1.svg";
export { ForwardRef as ReactComponent };